import { useEffect, useState } from 'react'

import { useWallet } from '@solana/wallet-adapter-react'

import { SolanaAddress } from '@src/types/token'

export const useSolanaWallet = () => {
    const [isSolanaConnected, setIsSolanaConnected] = useState<boolean>(false)
    const [solanaWalletAddress, setSolanaWalletAddress] = useState<SolanaAddress | undefined>(undefined)

    const { connected: solanaWalletConnected, publicKey: solanaPublicKey } = useWallet()

    useEffect(() => {
        if (solanaWalletConnected && solanaPublicKey) {
            setIsSolanaConnected(true)
            setSolanaWalletAddress(solanaPublicKey.toBase58() as SolanaAddress)
        } else {
            setIsSolanaConnected(false)
            setSolanaWalletAddress(undefined)
        }
    }, [solanaWalletConnected, solanaPublicKey])

    return {
        isSolanaConnected,
        solanaWalletAddress,
    }
}
